import React from "react";
import * as Icons from "lucide-react";
import { advantages, heroImages, siteInfo } from "../mock";

export default function About() {
  return (
    <section id="le-centre" className="py-20 lg:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-widest text-[#2c7a80] font-semibold">Qui sommes-nous</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium text-[#0e3a3f] leading-[1.05] mt-3 title-underline">
              Depuis {siteInfo.aupresDesEnfantsDepuis}<br />auprès des enfants.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-lg text-[#0e3a3f]/75 leading-relaxed">
              Le CFMPE incarne depuis 1996 les valeurs socles des métiers de la petite enfance.
              Notre direction dirige également plusieurs écoles maternelles et primaires internationales bilingues,
              ainsi que le collège-lycée international Lafayette.
            </p>
          </div>
        </div>

        {/* Image + narrative */}
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-14 mb-20 items-center">
          <div className="lg:col-span-6 relative">
            <div className="relative rounded-3xl overflow-hidden aspect-[5/4] shadow-xl">
              <img src={heroImages.classroom} alt="Classe petite enfance" className="w-full h-full object-cover" style={{ objectPosition: "center 15%" }} />
            </div>
            <div className="absolute -bottom-8 -right-4 lg:-right-8 bg-[#0e3a3f] text-white rounded-2xl p-6 max-w-xs shadow-xl">
              <div className="font-display text-4xl font-medium mb-1">29 ans</div>
              <div className="text-sm text-white/70">de transmission des savoirs et savoir-être aux futurs professionnels de la petite enfance.</div>
            </div>
          </div>

          <div className="lg:col-span-6 space-y-6">
            <div className="space-y-4">
              <h3 className="font-display text-2xl font-medium text-[#0e3a3f]">Une direction leader dans son domaine</h3>
              <p className="text-[#0e3a3f]/75 leading-relaxed">
                Notre direction partage son expérience avec plusieurs écoles maternelles et primaires internationales bilingues,
                ainsi qu'avec le collège-lycée international Lafayette. Cette expertise multi-établissements enrichit chaque jour la formation dispensée au CFMPE.
              </p>
            </div>
            <div className="space-y-4">
              <h3 className="font-display text-2xl font-medium text-[#0e3a3f]">Un état d'esprit qui fait la différence</h3>
              <p className="text-[#0e3a3f]/75 leading-relaxed">
                Nous transmettons à tous ceux qui souhaitent travailler auprès des enfants les connaissances
                et compétences nécessaires pour réussir dans ce domaine et obtenir le CAP AEPE.
              </p>
            </div>
            <div className="space-y-4">
              <h3 className="font-display text-2xl font-medium text-[#0e3a3f]">La formation pour tous, au service de tous</h3>
              <p className="text-[#0e3a3f]/75 leading-relaxed">
                La formation professionnelle permet à chacun d'acquérir et d'actualiser ses compétences,
                d'accroître son niveau de qualification et de favoriser son évolution professionnelle.
              </p>
            </div>
          </div>
        </div>

        {/* Advantages */}
        <div className="mb-10">
          <h3 className="font-display text-3xl md:text-4xl font-medium text-[#0e3a3f]">
            Le CFMPE ?
          </h3>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((a) => {
            const Icon = Icons[a.icon] || Icons.Star;
            return (
              <div
                key={a.title}
                className="group bg-white border border-[#e6ded0] rounded-2xl p-7 hover-lift relative overflow-hidden"
              >
                <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-[#2c7a80]/5 group-hover:bg-[#2c7a80]/10 transition-colors" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-[#2c7a80]/10 flex items-center justify-center mb-5 group-hover:bg-[#2c7a80] group-hover:text-white transition-colors">
                    <Icon className="w-6 h-6 text-[#2c7a80] group-hover:text-white transition-colors" />
                  </div>
                  <h4 className="font-display text-xl font-medium text-[#0e3a3f] mb-2">{a.title}</h4>
                  <p className="text-sm text-[#0e3a3f]/70 leading-relaxed">{a.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
